var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qb-calls-viewer',{attrs:{"customer-calls":_vm.customerCalls,"clear-call":_vm.clearCall}})}
var staticRenderFns = []

export { render, staticRenderFns }